import React from "react";
import { HowItWork } from "../components/home/how-it-work";
import FeaturedProperties from "../components/home/featured-properties";
import DownloadApp from "../components/home/download-app";
import Testimonials from "../components/home/testimonials";
import FaqSection from "../components/home/faq-section";
import HomeBlogs from "../components/home/home-blogs";
import { Helmet } from "react-helmet-async";
import aboutImage from "../assets/images/why-choose-us.png";
import ownerCta from "../assets/images/owner-cta.png";
import ownerCta1 from "../assets/images/owner-cta-1.png";
import HSRLayout from "../assets/images/areas/hsr.png";
import BTMLayout from "../assets/images/btm-layout.png";
import ElectronicCity from "../assets/images/areas/electronic-city.png";
import Whitefield from "../assets/images/areas/whitefield.png";
import Koramangala from "../assets/images/koramangala.png";
import Marathahalli from "../assets/images/areas/marathahali.png";
import Mahadevpura from "../assets/images/areas/mahadevpura.png";
import SarjapurRoad from "../assets/images/areas/sarjapura.png";
import { Link } from "react-router-dom";
import Banner from "../components/home/banner";
import NewlyArrivedProperties from "../components/home/newly-arrived-property";
import FastSellingProperties from "../components/home/fast-selling-properties";

const HomePage = () => {
  const locations = [
    {
      name: "HSR Layout",
      thumbImage: HSRLayout,
      link: "hsrlayout",
      hoverContent:
        "Affordable 1BHK & 2BHK flats for rent in HSR Layout – Find your perfect apartment with Sowerent.",
    },
    {
      name: "BTM Layout",
      thumbImage: BTMLayout,
      link: "btm-layout",
      hoverContent:
        "Find your perfect home near everything you love in BTM Layout with Sowerent.",
    },
    {
      name: "Electronic City",
      thumbImage: ElectronicCity,
      link: "electronic-city",
      hoverContent:
        "Rent 1BHK and 2BHK apartments in Electronic City – Prime location flats available!",
    },
    {
      name: "Whitefield",
      thumbImage: Whitefield,
      link: "whitefield",
      hoverContent:
        "Spacious 1BHK and 2BHK flats for rent in Whitefield – Premium apartments listed by Sowerent.",
    },
    {
      name: "Koramangala",
      thumbImage: Koramangala,
      link: "koramangala",
      hoverContent:
        "Style, social life, and serenity—get it all in Koramangala with Sowerent rentals. Book your ideal apartment today.",
    },
    {
      name: "Marathahalli",
      thumbImage: Marathahalli,
      link: "marathahalli",
      hoverContent:
        "Seamless city access and cozy living with rentals in Marathahalli by Sowerent.",
    },
    {
      name: "Mahadevpura",
      thumbImage: Mahadevpura,
      link: "mahadevpura",
      hoverContent:
        "Find budget-friendly 1BHK & 2BHK flats for rent in Mahadevpura – Available now on Sowerent.",
    },
    {
      name: "Sarjapur Road",
      thumbImage: SarjapurRoad,
      link: "sarjapur-road",
      hoverContent:
        "Premium 1BHK & 2BHK apartments for rent on Sarjapur Road – Browse our listings today.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          WeRentt - Rent or Lease Houses, Flats and Apartments in Bangalore
        </title>
        <meta
          name="description"
          content="Find verified rental and  lease homes, flats, and apartments in Bangalore with WeRentt. Enjoy zero brokerage, flexible lease options, and a seamless renting experience."
        />
        <meta
          name="keywords"
          content="rental properties in Bangalore, apartments for rent in Bangalore, 
          villas for rent in Bangalore, rental homes in Bangalore, WeRentt, houses for rent in Bangalore, Flats for rent in Bangalore,
          property listings in Bangalore, Houses for lease in Bangalore, Apartments for lease in Bangalore, Flats for lease in Bangalore,
            affordable rentals in Bangalore, rental marketplace in Bangalore"
        />
      </Helmet>
      <div className="main-wrapper">
        <Banner />
        <NewlyArrivedProperties />
        <FastSellingProperties />
        <FeaturedProperties />
        {/* <CityListing /> */}
        <section className="why-choose-us">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 mx-auto">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-6">
                    <div className="section-heading align-items-start">
                      <h2>
                        Why choose WeRentt for flat{" "}
                        <span className="pink-text">
                          {" "}
                          rentals in Bangalore?
                        </span>
                      </h2>
                      <p>
                        The answer to your flat renting platform in Bangalore
                      </p>
                    </div>
                    <div className="about-content">
                      <p>
                        At WeRentt, we help you make renting easier and
                        stress-free. Are you a homeowner looking to lease your
                        flat or house, or a tenant searching for the perfect
                        place to call home? We have got you covered with our
                        flat rental solutions in Bangalore.
                      </p>
                      <p>
                        Our platform connects you directly—no middlemen, no
                        brokerage, no commissions. Just smooth, straightforward
                        rentals tailored to your needs.
                      </p>
                      <ul>
                        <li>
                          <img
                            src={
                              "https://www.nextwebi.com/assets/images/check-mark.png"
                            }
                            alt=""
                          />
                          <span>
                            Fully furnished flats and houses ready to move in
                          </span>
                        </li>
                        <li>
                          <img
                            src={
                              "https://www.nextwebi.com/assets/images/check-mark.png"
                            }
                            alt=""
                          />
                          <span>
                            Perfect for short-term stays or long-term living
                          </span>
                        </li>
                        <li>
                          <img
                            src={
                              "https://www.nextwebi.com/assets/images/check-mark.png"
                            }
                            alt=""
                          />
                          <span>
                            Open to families, couples, friends, and singles
                          </span>
                        </li>
                        <li>
                          <img
                            src={
                              "https://www.nextwebi.com/assets/images/check-mark.png"
                            }
                            alt=""
                          />
                          <span>
                            Everything handled under one roof—from listing to
                            move-in
                          </span>
                        </li>
                        <li>
                          <img
                            src={
                              "https://www.nextwebi.com/assets/images/check-mark.png"
                            }
                            alt=""
                          />
                          <span>Flats available in gated community also</span>
                        </li>
                      </ul>
                      <div className="mt-5">
                        <Link
                          className=" btn btn-primary d-inline-block rounded"
                          to={"#"}
                        >
                          Know More About Us
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-6">
                    <div className="about-image">
                      <img src={aboutImage} alt="" />
                    </div>
                  </div>
                </div>
                <HowItWork isBuildingSectionRequired={false} />
              </div>
            </div>
          </div>
        </section>
        <section className="located-in">
          <div className="container">
            <div className="row location-card-row">
              <div className="col-12">
                <div className="section-heading align-items-start">
                  <h2>
                    {" "}
                    Popular localities in Bangalore for renting houses and
                    flats.
                  </h2>
                  <p>Find your tribe, live your life</p>
                </div>
              </div>
              {locations?.map((location, index) => (
                <div className="col-6 col-sm-6 col-md-4 col-lg-3">
                  <Link
                    className="located-in-card"
                    to={`rent/flats-for-rent-in-${"bangalore"}/${
                      location.link
                    }`}
                  >
                    <div className="located-in-thumb">
                      <img src={location.thumbImage} alt="" />
                      <div className="hover-content">
                        <p>{location.hoverContent}</p>
                      </div>
                    </div>
                    <h3>{location.name}</h3>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Testimonials />

        <DownloadApp />
        <section className="list-property-rent">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 col-xl-10 mx-auto">
                <div className="section-heading align-items-start">
                  <h2>Want to rent your house or flat ?</h2>
                </div>
                <div className="list-prop-card">
                  <h3>
                    Connect with WeRentt today <br /> and rent it today.
                  </h3>
                  <Link className=" btn btn-primary d-inline-block rounded ">
                    Rent your Property
                  </Link>
                  <div className="image-element-1">
                    <img src={ownerCta} alt="" />
                  </div>
                  <div className="image-element-2">
                    <img src={ownerCta1} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FaqSection />
        <HomeBlogs />
        {/* <SocialMedia /> */}
      </div>
      {/* <div className="progress-wrap active-progress">
        <svg className="progress-circle svg-content" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div> */}
    </>
  );
};

export default HomePage;
